/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListAppointmentsRequest} from '@cash-web/protos/squareup/cash/local/client/v1/local_appointment.pb'
import {ListAppointmentsResponse} from '@cash-web/protos/squareup/cash/local/client/v1/local_appointment.pb'


export const listAppointments = (request: ListAppointmentsRequest, options?: CashRequestOptions) => post<ListAppointmentsRequest, ListAppointmentsResponse>("/2.0/cash/list-appointments", request, {...options, rejectOnError: true })